import {FormInstance} from 'antd';

import {ReviewBrandCompanyScopeCard} from '../../review-brand-company-scope-card/review-brand-company-scope-card';

import {ImportReviewsFormFieldNamesEnum, ImportReviewsFormFieldsType} from './import-reviews-form-type';

type PropsType = {
    form: FormInstance<ImportReviewsFormFieldsType>;
};

export function ImportReviewsBrandCompanyScopeCard(props: PropsType): JSX.Element {
    const {form} = props;

    return (
        <ReviewBrandCompanyScopeCard
            fieldNames={{
                entityScope: ImportReviewsFormFieldNamesEnum.entityScope,
                brand: ImportReviewsFormFieldNamesEnum.brand,
                company: ImportReviewsFormFieldNamesEnum.company,
            }}
            form={form}
        />
    );
}
